const SET_HEADERS = 'SET_HEADERS';

export const setHeaders = headers => {
  return { type: SET_HEADERS, headers };
};



// WEBPACK FOOTER //
// ./src/reducers/headers.js